// @flow
import { get } from '../../utils/fetch'

export const getDownload = (id: string, token?: string) => {
  console.log({ id, token })
  const download = get(`/download/${id}`, { token })
  return download
}

export const getUrl = (id: string, soundId: string) => {
  const url = get(`/download/${id}/download/${soundId}`)
  return url
}

export const getMediaDownload = (soundId: string) => {
  const url = get(`/download/media/${soundId}`)
  return url
}

export const getMyDownload = (page = 1, perPage = 20, token?: string) => {
  const download = get(`/download/my?page=${page}&perPage=${perPage}`, {
    token,
  })
  return download
}
